// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
 import { getFirestore , collection, getDocs, doc, query, orderBy, limit,getDoc } from "firebase/firestore";
import {  getStorage, ref  } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD4ZWO6T8jw7YnMCvRNwWLpZ8cvpMYtnwk",
  authDomain: "getriad-f23ed.firebaseapp.com",
  projectId: "getriad-f23ed",
  storageBucket: "getriad-f23ed.firebasestorage.app",
  messagingSenderId: "97394850919",
  appId: "1:97394850919:web:4d6cb6bd4a172844d0a8c2",
  measurementId: "G-RG927GLVMY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
// const analytics = getAnalytics(app);
 const db = getFirestore(app);
 const storage = getStorage(app);
export { auth,db ,  collection, getDocs ,doc,storage, ref, query, orderBy, limit,getDoc };